<template>
	<div>
		<!--面包屑导航区域-->
		<div class="crumbs">
			<el-breadcrumb separator="/">
				<el-breadcrumb-item>
					<i class="el-icon-video-camera"></i> 设备管理
				</el-breadcrumb-item>
		    </el-breadcrumb>
		</div>
		<div class="container">
			<el-form :model="query" ref="query">
				<!-- 检索 -->
				<div class="handle-box">
					<el-row>
						<el-col :span="22">
							<div class="grid-content bg-purple">
								<!--搜索与添加-->
								<el-input v-model="query.devi" clearable :placeholder="'请输入设备码'" class="handle-input mr10" style="width: 15%;"></el-input>
								<el-input v-model="query.denm" clearable :placeholder="'请输入设备名称'" class="handle-input mr10" style="width: 15%;"></el-input>
								<el-select v-model="query.valueSBASAAI" clearable filterable
								:placeholder="'请选择所属幼儿园'" class="handle-select mr10" style="width: 15%;">
								  <el-option
								  	v-for="item in query.optionsSBASAAI"
								  	:key="item.SAAMSID"
								  	:label="item.SAANAME"
								  	:value="item.SAAMSID">
								  </el-option>
								</el-select>
								<el-checkbox style="margin-left: 10px;" v-model="checked" @change='changeData'>显示删除状态数据</el-checkbox>
								<!-- <el-select v-model="query.delf" clearable :placeholder="'请选择删除状态'" class="select-shop mr10">
									<el-option v-for="item in query.optionsStat" :key="item.INIKEY2" :label="item.INIDISP" :value="item.INIKEY2"></el-option>
								</el-select> -->
							</div>
						</el-col>
						<el-col :span="2">
							<div class="grid-content bg-purple-light">
								<el-button type="warning" :disabled="!hasPerms(buttonPerms.searchPerms)" class="float" icon="el-icon-search"@click="handleSearch">搜索</el-button>
							</div>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="22">
							<div class="grid-content bg-purple">
								<!-- <el-button type="danger" :disabled="!hasPerms(buttonPerms.batchdelPerms)" icon="el-icon-delete" class="handle-del" @click="delAllSelection">批量删除</el-button> -->
								<!-- <el-button type="info" :disabled="!hasPerms(buttonPerms.exportPerms)" icon="el-icon-download" @click="tableToExcel">Excel导出</el-button> -->
							</div>
						</el-col>
						
						<el-col :span="2">
							<div class="grid-content bg-purple-light">
								<el-button type="primary" :disabled="!hasPerms(buttonPerms.addPerms)" icon="el-icon-plus" @click="handleAdd">添加设备</el-button>
							</div>
						</el-col>
					</el-row>
				</div>
				
				<!-- 列表 -->
				<el-table :data="tableData" border class="table" :default-sort="{prop: 'CAAINDT', order: 'descending'}"
				 header-cell-class-name="table-header" :row-key="getRowKeys" v-loading="loading">
					<el-table-column type="index" :label="'序列号'" width="80" align="center"></el-table-column>
					<el-table-column prop="ZAADEVI" :label="'设备码'"align="center" width="150"></el-table-column>
					<el-table-column prop="ZAADENM" :label="'设备名称'" align="center" ></el-table-column>
					<el-table-column prop="SAANAME" :label="'所属幼儿园'" align="center" ></el-table-column>
					
					<el-table-column :label="'删除状态'" align="center" width="150">
					<template slot-scope="scope">
						<span style="display: block;">
							{{scope.row.ZAADELF.name}}
						</span>
					</template>
					
					</el-table-column>
					<el-table-column :label="'操作'" align="center">
						<template slot-scope="scope">
							<!-- <el-button type="text" :disabled="!hasPerms(buttonPerms.editPerms)" icon="el-icon-edit" @click="handleEdit(scope.$index, scope.row)">编辑</el-button> -->
							<el-button type="text" 
							:disabled="!hasPerms(buttonPerms.deletePerms) || scope.row.ZAADELF.ZAADELF === '0' ? false : true"
							icon="el-icon-delete" class="red" 
							@click="handleDelete(scope.$index, scope.row)"
							>删除</el-button>
						</template>
					</el-table-column>
				</el-table>
				
				<div class="pagination">
					<el-pagination background layout="total, prev, pager, next, jumper" :current-page="this.query.pageIndex"
					 :page-size="this.query.pageSize" :total="this.pageTotal" @size-change="handleSizeChange" @current-change="handlePageChange"></el-pagination>
				</div>
				
			</el-form>
		</div>
	</div>
</template>

<script>
	import {hasPermission} from '@/permission/index.js'
	export default {
		name: 'deviceZAAList',
		inject: ['reload'], //在子组件中通过inject调用
		data() {
			return {
				//页面按钮权限
				buttonPerms: {
					addPerms: 'monitorCAA:monitorCAAList:add', //新增权限标识
					searchPerms: 'monitorCAA:monitorCAAList:search', //搜索权限标识
					editPerms: 'monitorCAA:monitorCAAList:edit', //编辑权限标识
					deletePerms: 'monitorCAA:monitorCAAList:delete', //删除权限标识
					//batchdelPerms: 'monitorCAA:monitorCAAList:batchdel', //批量删除权限标识
					//exportPerms: 'monitorCAA:monitorCAAList:export', //
					disabled: false
				},
				web_suuid: sessionStorage.getItem("ms_web_suuid"),
				web_sphon: sessionStorage.getItem("ms_username"), //web 登录用户
				query: {
					
					valueSBASAAI:'',
					optionsSBASAAI: '',
					
					valueCAANOST:'',
					optionsCAANOST: '',
					
					optionsStat: '',
					
					devi: '',
					denm: '',
					delf: '0',
					
					start: '',
					end: '',
					pageIndex: 1, //当前页
					pageSize: 10 //这是当前每页显示的条数
				},
				tableData: [],
				pageTotal: 0, // 总条数
				loading: false,
				checked: false //显示有效数据
			}
		},
		created() {
			let curpagenum = this.query.pageIndex; //当前页码
			this.getSAA();
			this.getStat();
			this.getData(curpagenum); //获取当前列表数据
			this.get_ZAA_List_Count(); //获取当前列表条数
		},
		methods: {
			hasPerms: function(perms) {
				// 根据权限标识和外部指示状态进行权限判断
				return hasPermission(perms) & !this.buttonPerms.disabled
			},
			//获取幼儿园信息
			getSAA(){
				const self_agent = this;
				var postUrl='WCF/WEB/svcSAA.svc/Get_SAA_GardenList';
				//网络请求接口
				this.$axios.post(
					//请求的url
						postUrl,
					//请求参数
					{ 
						sPHON: self_agent.web_sphon, //web侧 登录ID  tihs.web_suuid
					}
				)
				.then((response) =>{
					//请求成功返回的数据
					let resCount = response.data.KKDTCOUNT;
					if(resCount>0){
						this.query.optionsSBASAAI = response.data.KKDT;
						response.data.KKDT.forEach((team, index) => {
							this.query.optionsSBASAAI[index].SAANAME = team.SAANAME;
							this.query.optionsSBASAAI[index].SAAMSID = team.SAAMSID;
						})
					}		
				})
				.catch((error) =>{
					this.$message({
					  message: '获取幼儿园信息请求失败',  //请求失败
					  type: 'error'
					});
				});	
			},
			//获取删除状态
			getStat() {
				const self_shop = this;
				var postUrl = 'WCF/WEB/svcINI.svc/Get_INI_List';
				//网络请求接口
				this.$axios.post(
						//请求的url
						postUrl,
						//请求参数
						{
							sPHON: self_shop.web_sphon, //web侧 登录邮箱
							sINIKEY1: 10005 //店铺分类状态  10017
						}
					)
					.then((response) => {
						//请求成功返回的数据
						let resCount = response.data.KKDTCOUNT;
						if (resCount > 0) {
							this.query.optionsStat = response.data.KKDT;
							response.data.KKDT.forEach((team, index) => {
								this.query.optionsStat[index].name = team.INIDISP;
								this.query.optionsStat[index].SBASTAT = team.INIKEY2;
							})
						}
					})
					.catch((error) => {
						this.$message({
							message: '获取删除状态失败', //请求失败
							type: 'error'
						});
					});
			},
			// 获取当前列表条数
			get_ZAA_List_Count() {
				const self_count = this;
				var postUrl = 'WCF/WEB/svcZAA.svc/Get_ZAA_List_Count';
				//网络请求接口
				this.$axios.post(
					//请求的url
					postUrl,
					//请求参数
					{
						sPHON: self_count.web_sphon, //web侧 登录ID  tihs.web_suuid
						sDEVI: self_count.query.devi,
						sDENM: self_count.query.denm.trim(),
						sSAAI: self_count.query.valueSBASAAI,
						sDELF: self_count.query.delf
					}
				)
				.then((response) => {
					//请求成功返回的数据
					let resCount = response.data.KKDTCOUNT;
					this.pageTotal = Number(resCount); //总条数
				})
				.catch((error) => {
					this.$message({
						message: '获取设备信息失败', //请求失败
						type: 'error'
					});
				});
			},
			// 获取视频信息数据
			getData(curpage) {
				this.loading = true; //初始化加载loading效果
				const self_count = this;
				var postUrl = 'WCF/WEB/svcZAA.svc/Get_ZAA_List';
				//debugger;
				//网络请求接口
				this.$axios.post(
					//请求的url
					postUrl,
					//请求参数
					{
						sPHON: self_count.web_sphon, //web侧 登录ID  tihs.web_suuid
						sDEVI: self_count.query.devi,
						sDENM: self_count.query.denm.trim(),
						sSAAI: self_count.query.valueSBASAAI,
						sDELF:self_count.query.delf,
						sPageIndex: curpage, //页码
						sPageSize: self_count.query.pageSize //每页显示条数
				
					})
				.then((response) => {
					this.loading = false; //取消loading效果
					//请求成功返回的数据
					let resCount = response.data.KKDTCOUNT;
					let resKKDT = response.data.KKDT;
					if (resCount > 0) {
						resKKDT.forEach((team, index) => {
							if (team.ZAADELF === '0') {
								resKKDT[index].ZAADELF = {
									ZAADELF: '0',
									name: '有效'
								};
							} else if (team.ZAADELF === '1') {
								resKKDT[index].ZAADELF = {
									ZAADELF: '1',
									name: '删除'
								};
							}
							
						})
						//渲染数据 List
						this.tableData = resKKDT; //数据数组
						//console.log(resKKDT);
					} else {
						this.tableData = []; //数据数组
					}
				})
				.catch((error) => {
					this.loading = false; //取消loading效果
					this.$message({
						message: '获取设备信息失败', //请求失败
						type: 'error'
					});
				});
			
			},
			// 触发搜索按钮
			handleSearch() {
				this.$set(this.query, 'pageIndex', 1);
				this.getData(1);
				this.get_ZAA_List_Count(); //获取当前列表条数
			},
			// 触发新增按钮
			handleAdd() {
				this.$router.push('/addDeviceZAA'); // 跳转路由
			},
			handleDelete(index, row) {
				
				if(row.ZAADELF.ZAADELF === '1'){
					this.$message.success('此数据已被删除');
					return;
				}
				
				const self = this;
				console.log(row.ZAADELF + " " + self.web_sphon)
				// 二次确认删除
				this.$confirm('此操作将删除该信息, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				})
				.then(() => {
					//删除接口
					const self = this;
					var postUrl = 'WCF/WEB/svcZAA.svc/DEL_ZAA';
					//网络请求接口
					this.$axios.post(
						//请求的url
						postUrl,
						//请求参数
						{
							sPHON: self.web_sphon,
							sMSID: row.ZAAMSID
						}
					)					
					.then((response) => {
						//请求成功返回的数据
						let resStatus = response.status; //200 代表请求成功
						let resKKSTR = response.data.KKSTR;
						
						if (resStatus == "200") {
							if (resKKSTR == "N") {
								this.$message({
									message: '数据删除失败', //删除失败
									type: 'error'
								});
							} 
							else if (resKKSTR == "Y") {
								this.$message.success('数据删除成功'); //删除成功
								this.tableData.splice(index, 1);
				
								//刷新当前页面
								this.reload()
							}
						} else {
							this.$message({
								message: '删除请求失败1', //请求失败
								type: 'error'
							});
						}
					})
					.catch((error) => {
						this.$message({
							message: '删除请求失败', //请求失败
							type: 'error'
						});
					});
				})
			},
			getRowKeys(row) {
				return row.ZAAMSID; // id为列表数据的唯一标识
			},
			// 分页导航 currentPage 改变时会触发
			handlePageChange(currentPage) {
				this.$set(this.query, 'pageIndex', currentPage);
				// 调取列表的函数，初始化时调一次
				this.getData(currentPage);
			},
			//pageSize 改变时会触发
			handleSizeChange(size) {
				this.$set(this.query, 'pageIndex', 1);
				this.$set(this.query, 'pageSize', size);
				// 调取列表的函数，初始化时调一次
				this.getData(size);
			},
			changeData(value) {
				if (this.checked) //显示删除数据
				{
				    this.query.stat = '';
				} 
				else  //显示有效数据
				{
				    this.query.stat = '0';
				}
			},
		}
	}
	
</script>

<style scoped>
	.handle-box {
		margin-bottom: 20px;
	}

	.handle-select {
		width: 12%;
	}


	.table {
		width: 100%;
		font-size: 14px;
	}

	.red {
		color: #ff0000;
	}

	.black {
		color: #000000;
	}

	.mr10 {
		margin-right: 10px;
	}

	.table-td-thumb {
		display: block;
		margin: auto;
		width: 40px;
		height: 40px;
	}

	.select-shop {
		width: 16%;
	}

	.select-agent {
		width: 14%;
	}

	.el-row {
		margin-top: 15px;
	}

	.bg-purple {
		text-align: left;
	}

	.bg-purple-light {
		text-align: right;
	}

	.grid-content {
		min-height: 34px;
	}

	.handle-input {
		width: 250px;
	}

	.el-input--small .el-input__inner {
		height: 36px;
		line-height: 36px;
		font-size: 14px;
	}

	.el-upload--text {
		width: 140px;
		height: 80px;
	}

	.avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 140px;
		height: 80px;
		line-height: 80px;
		text-align: center;
	}

	.avatar {
		width: 140px;
		height: 80px;
		display: block;
	}

	.el-dialog__footer {
		text-align: center;
	}

	.dialog-footer-btn {
		margin-right: 20px;
	}

	.cropper {
		width: auto;
		height: 300px;
	}
</style>
